import { TemplateFormValues, StagesFormValues, TemplateConstructorMode } from '../../types';

export const initialStagesConstructorFormValue: TemplateFormValues = {
  isActive: false,
  description: '',
  templateName: '',
  businessProcess: '',
  applyRules: {
    paymentType: '',
    applyingFor: '',
  },
};

export const stagesConstructorFormRow: StagesFormValues = {
  id: null,
  name: '',
  recipients: [],
  winProbability: 0,
  listOfAttributes: [],
};

export const constructorSubmitLabelByMode: Record<TemplateConstructorMode, string> = {
  create: 'Create',
  edit: 'Save',
  copy: 'Copy',
};
